<template>
  <div class="changelog mails">
    <div>
      <div v-for="(mval, mkey) in mails" :key="mkey">
        <span class="user">{{ user(mval.user_id) }} - {{ time(mval.created_at) }}</span>
        <table>
            <tr>
              <td style="width: 140px">{{ _.from }}:</td>
              <td>{{ mval.from }}</td>
            </tr>
            <tr v-if="mval.to">
              <td style="width: 140px">{{ _.to }}:</td>
              <td>{{ mval.to }}</td>
            </tr>
            <tr v-if="mval.reply_to">
              <td style="width: 140px">{{ _.reply_to }}:</td>
              <td>{{ mval.reply_to }}</td>
            </tr>
            <tr v-if="mval.cc">
              <td style="width: 140px">{{ _.cc }}:</td>
              <td>{{ mval.cc }}</td>
            </tr>
            <tr v-if="mval.bcc">
              <td style="width: 140px">{{ _.bcc }}:</td>
              <td>{{ mval.bcc }}</td>
            </tr>
            <tr>
              <td style="width: 140px">{{ _.subject }}:</td>
              <td><b>{{ mval.subject }}</b></td>
            </tr>
            <tr>
              <td style="width: 140px">{{ _.message }}:</td>
              <td class="message">
                <div>
                  <div v-html="mval.body"></div>
                </div>
              </td>
            </tr>
            <tr>
              <td style="width: 140px">{{ _.status }}:</td>
              <td>{{ mval.status }}</td>
            </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { API_URL } from '@/config'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc';
export default {
  props: ['model', 'id'],
  data() {
    return {
      users: [],
      mails: [],
    }
  },
  methods: {
    time(created) {
      const date = dayjs.utc(created);
      return date.local().format(this._.date_format_comments);
    },
    user(id) {
      let data = this.users.find(user => user.id === id);
      return (data) 
        ? data.first_name + ' ' + data.last_name
        : 'System';
    },
  },
  async created() {
    dayjs.extend(utc);
    const mails = await this.axios.get(API_URL + '/persons/' + this.$route.params.id + '/mail/changelog');
    this.setProgress(false);
    this.users = mails.data.users;
    this.mails = mails.data.mails;
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variables';
.changelog.mails {
  position: absolute;
  top: 0;
  right: 0;
  width: 680px;
  height: 100%;
  opacity: .9;
  > div {
    background: #ffffff;
    border-left: 1px solid lighten($primary-color, 80%);
    position: sticky;
    top: 0;
    height: calc(100vh - 178px);
    overflow-y: scroll;
    > div {
      padding: 12px;
      &:not(:first-child) {
        border-top: 1px solid lighten($primary-color, 80%);
      }
      > span {
        display: inline-block;
        opacity: .4;
        padding-left: 2px;
        margin-bottom: 3px;
        border-bottom: 0;
      }
      > table {
        > tr {
          > td {
            vertical-align: top;
            &.message {
              > div {
                background: #f4f4f4;
                border-radius: 4px;
                overflow: hidden;
                > div {
                  max-height: 120px;
                  overflow-y: scroll;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>